import { Admin } from 'admin';
import { useIdentifyUser } from 'api';
import { PersonSearch } from 'ui/icons';

import { Router } from './Router';

export const App = () => {
  useIdentifyUser();

  return (
    <Admin
      resources={[
        {
          create: '/inspections/create',
          list: '/inspections',
          meta: {
            icon: <PersonSearch />,
            label: 'Inspections',
          },
          name: 'inspections',
          show: '/inspections/:id',
        },
        {
          list: '/inspections/loads',
          meta: {
            label: 'Loads',
          },
          name: 'loads',
        },
        {
          list: '/inspections/companies',
          meta: {
            label: 'Companies',
          },
          name: '/inspection-companies',
        },
        {
          list: '/inspections/inspectors',
          meta: {
            label: 'Inspectors',
          },
          name: '/inspectors',
        },
      ]}
    >
      <Router />
    </Admin>
  );
};
